import {APPEND_NOTIFICATION, GET_USER_NOTIFICATION, SET_LIMIT, UPDATE_USER_NOTIFICATION} from 'actions/types'

const initial = {
  notificationData: [],
  isReadNotification: [],
  limit: 30,
}
export default function (state = initial, action) {
  switch (action.type) {
    case GET_USER_NOTIFICATION:
      return {
        ...state,
        notificationData: [...(action.payload.data || [])],
        isReadNotification: [...state.isReadNotification],
      }

    case APPEND_NOTIFICATION: {
      return {
        ...state,
        notificationData: [action.payload || {}, ...state.notificationData],
      }
    }

    case UPDATE_USER_NOTIFICATION: {
      return {
        ...state,
        notificationData: [...(action.payload.data || [])],
        isReadNotification: [...state.isReadNotification, action.payload] || [],
      }
    }
    case SET_LIMIT: {
      return {
        ...state,
        limit: state.limit + 30,
      }
    }

    default:
      return state
  }
}
